<template>
<form @submit.prevent="onsubmit">
  <va-input
    v-model="email"
    type="email"
    :label="$t('auth.email')"
    :error="!!emailErrors.length"
    :error-messages="emailErrors"
  />

  <va-input
    v-model="password"
    type="password"
    :label="$t('auth.password')"
    :error="!!passwordErrors.length"
    :error-messages="passwordErrors"
  />

  <div class="auth-layout__options d-flex align--center justify--space-between">
    <va-checkbox v-model="keepLoggedIn" class="mb-0" :label="$t('auth.keep_logged_in')"/>
    <router-link class="ml-1 link" :to="{name: 'recover-password'}">{{$t('auth.recover_password')}}</router-link>
  </div>

  <div class="d-flex justify--center mt-3">
    <va-button type="submit" class="my-0"> Se connecter </va-button>
  </div>
</form>
</template>

<script>
import service from "../../../providers/service";

export default {
  name: 'login',
  data () {
    return {
      email: '',
      password: '',
      keepLoggedIn: false,
      emailErrors: [],
      passwordErrors: [],
    }
  },
  computed: {
    formReady () {
      return !this.emailErrors.length && !this.passwordErrors.length
    },
  },
  methods: {
    onsubmit () {
      this.emailErrors = this.email ? [] : ['Email is required']
      this.passwordErrors = this.password ? [] : ['Password is required']
      if (!this.formReady) {
        return
      }else
      {
        const credentials = { email : this.email, password : this.password, ttl:60*20}
       // this.$store.commit('LOADER', true);
        service.userLogin(credentials)
        .then( res => {
      //    this.$store.commit('LOADER', false);
          
            console.log(res);

            if(res.status == 200){
              
              localStorage.user = JSON.stringify(res.data)

              localStorage.userAccesstoken = res.data.id

              this.$router.push({ path: '/' })
            }
        })
        
      }
    },
  },
}
</script>

<style lang="scss">
</style>
